import { memo } from 'react';
import { IconWallet } from '../icons';

const PINK_FILL = '#FE37B4';

export interface BetButtonProps {
  onClick?: () => void;
  size?: number;
  /** Render with the danger style (e.g. bet exceeds balance). */
  danger?: boolean;
  /** When true, the button is unclickable and visually muted. */
  disabled?: boolean;
}

// Memoized — see SlotUI's `handleOpenBet` for the matching stable-callback
// half of this fix.
export const BetButton = memo(function BetButton({
  onClick,
  size = 48,
  danger = false,
  disabled = false,
}: BetButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title="Change bet"
      aria-label={danger ? 'Change bet — insufficient balance' : 'Change bet'}
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        background: PINK_FILL,
        color: '#FFFFFF',
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        padding: 0,
        outline: 'none',
        transition: 'transform 0.15s ease',
        animation: danger && !disabled ? 'reelay-betBtnPulse 1.6s ease-in-out infinite' : 'none',
        // Same ring/glow as SpinButton, but the 1px edge uses the button's
        // own pink instead of white — a white ring read too stark against
        // a solid pink fill.
        boxShadow: '0 6px 24px rgba(0,0,0,0.35), 0 0 0 1px #FE37B4, 0 0 0 5px var(--border-2)',
      }}
      onMouseEnter={(e) =>
        !disabled && (e.currentTarget.style.transform = 'translateY(-1px)')
      }
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'none')}
    >
      <IconWallet size={size >= 52 ? 30 : 24} />
    </button>
  );
});
